// extracted by mini-css-extract-plugin
module.exports = {"image":"FamilyBannerShopImage_image__zNYeK"};